
<template>
  <section class="section">
    <!-- Tab Navigation -->
    <div class="tab">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab__item"
        :class="{ 'tab__item--active': activeTab === index }"
        @click="setActiveTab(index)"
      >
        {{ $t(tab.label) }}
      </div>
    </div>

    <!-- Tab Content -->
    <div class="tab__content" v-show="activeTab === 0">
      <DefaultTabsWinners/>
    </div>

    <div class="tab__content" v-show="activeTab === 1">
      <DefaultTabsHowToPlay/>
    </div>

    <div class="tab__content" v-show="activeTab === 2 && userStore.isLoggedIn">
      <DefaultTabsGameProfile @logout="logout" />
    </div>
  </section>
</template>

<script setup lang="ts">
import {ref} from "vue";

const userStore = useUserStore()
const activeTab = ref<number>(0)

const tabs = computed(() => {
  const list = [
    { label: 'tabs.winners' },
    { label: 'tabs.how-to-play' },
  ]
  if (userStore.isLoggedIn) {
    list.push({ label: 'tabs.profile' })
  }
  return list
})
const setActiveTab = (index: number) => {
  activeTab.value = index
}

const logout = async () => {
  setActiveTab(0)
  const scrollToTop = useScrollToTopDebounce()
  scrollToTop()
}
</script>